import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Home from '../screens/Home/Home';
import Contacts from '../screens/Contacts/Contacts';
// import CallForSpeakers from '../screens/CallForSpeakers/CallForSpeakers';
import SpeakersContainer from '../screens/Speakers/Speakers';
import SpeakerDetailsContainer from '../screens/SpeakerDetails/SpeakerDetails';
import ProgramContainer from '../screens/Program/Program';
import TalkDetailContainer from '../screens/TalkDetail/TalkDetail';
import LocationMap from '../screens/LocationMap/LocationMap';
// import Livestream from '../screens/Livestream/Livestream';
// import FeedbackForm from '../screens/FeedbackForm/FeedbackForm';

export const Routes = () => {
  return (
    <Route>
      <Navbar />
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={Contacts} exact path="/contacts" />
        {/* <Route component={CallForSpeakers} exact path="/cfs" /> */}
        <Route component={LocationMap} exact path="/location-map" />
        <Route component={SpeakersContainer} exact path="/speakers" />
        <Route component={SpeakerDetailsContainer} exact path="/speakers/:speakerId" />
        <Route component={ProgramContainer} exact path="/program" />
        <Route component={ProgramContainer} exact path="/workshops" />
        <Route component={TalkDetailContainer} exact path="/program/:talkId" />
        {/* <Route component={Livestream} exact path="/livestream" /> */}
        {/* <Route component={FeedbackForm} exact path="/ff" /> */}

        <Route exact path="/workshops/1">
          <Redirect to="/program/de9ade6d-2f51-44ae-8f9f-bb630b72aa9e" />
        </Route>
        <Route exact path="/workshops/2">
          <Redirect to="/program/d045c782-cfbf-4ca8-b16f-27563a53ebcb" />
        </Route>
        <Route exact path="/workshops/3">
          <Redirect to="/program/fc3786d9-f848-4982-a9e7-2c8ef173c5e1" />
        </Route>
        <Route exact path="/workshops/4">
          <Redirect to="/program/737e70fd-321c-40db-b26d-f382b4e0791b" />
        </Route>
        <Route exact path="/workshops/5">
          <Redirect to="/program/f0f4fb9a-c327-46ea-9fae-5d1c9ac052bd" />
        </Route>
        <Route exact path="/workshops/6">
          <Redirect to="/program/debb4aa0-37db-4d87-8c94-2bcf2dfedbcb" />
        </Route>
        <Route exact path="/workshops/7">
          <Redirect to="/program/67560544-5991-476e-8060-50303ae6d1a9" />
        </Route>
        <Route exact path="/workshops/8">
          <Redirect to="/program/092b9100-89b4-44f7-b5b9-7dac375dc1db" />
        </Route>
      </Switch>
    </Route>
  );
};

const RouterContainer = props => (
  <Router {...props}>
    <Routes />
  </Router>
);

export default RouterContainer;
